module.exports = __webpack_public_path__ + "static/media/3_2_markdown.73330c6a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/3_2_markdown.mp4
// module id = 313
// module chunks = 0